module.exports = __webpack_public_path__ + "img/Impact assessment-Mitigation measures.d9ed14c4.svg";